<template>
  <div class="widget">
    <div class="widget-heading">
      <h2 class="textStyle">{{ $tc("studea_manager.training.title", 1) }} : {{ training.name }}</h2>
    </div>
    <div class="widget-content position-relative">
      <div class="panel-body simple-pills tabs">
        <ul id="trainingTab" class="nav nav-pills" role="tablist">
          <li v-for="tab in tabs" :key="tab.code" class="nav-item" role="presentation">
            <a
              :id="'tab-' + tab.code + '-tab'"
              :ref="'ref-' + tab.code"
              :aria-controls="'tab-' + tab.code"
              :aria-selected="currentTabCode && currentTabCode === tab.code"
              :class="
                'nav-link mb-2 text-center bgStyle h-100' +
                (currentTabCode && currentTabCode === tab.code ? ' active' : '')
              "
              :href="'#tab-' + tab.code"
              data-bs-toggle="pill"
              role="tab"
              @click="toggleTab(tab.code)"
            >
              {{ tab.title }}
            </a>
          </li>
        </ul>
        <div id="trainingTabContent" class="tab-content">
          <div
            v-for="tab in tabs"
            :key="tab.code"
            :id="'tab-' + tab.code"
            :aria-labelledby="'tab-' + tab.code + '-tab'"
            :class="'tab-pane fade' + (currentTabCode && currentTabCode === tab.code ? ' show active' : '')"
            role="tabpanel"
          >
            <TrainingGeneralInfoComponent v-if="tab.code === 'info'" :logo="logo" :training="training" />
            <TrainingRncpComponent
              v-if="tab.code === 'rncp'"
              :training="training"
              :active="currentTabCode === 'rncp'"
              @refresh="refresh"
            />
            <TrainingProgramComponent
              v-if="tab.code === 'program'"
              :training="training"
              :active="currentTabCode === 'program'"
              @refresh="refresh"
            />
            <TrainingNpecComponent
              v-if="tab.code === 'npec'"
              :models="npecModels"
              :cpneList="cpneList"
              :training="training"
              @updateField="updateField"
            />
            <TrainingSettingsComponent v-if="tab.code === 'settings'" :models="settingsModels" />
          </div>
        </div>
      </div>
      <BlockLoader :loading="loading" />
    </div>
  </div>
</template>

<script>
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import TrainingNpecComponent from "@/components/training/TrainingNpecComponent.vue";
import TrainingGeneralInfoComponent from "@/components/training/TrainingGeneralInfoComponent.vue";
import TrainingRncpComponent from "@/components/training/rncp/TrainingRncpComponent.vue";
import TrainingProgramComponent from "@/components/training/program/TrainingProgramComponent.vue";
import { moduleManager } from "@/services/module/module-manager";
import { moduleConstantes } from "@/constantes/module";
import TrainingSettingsComponent from "@/components/training/TrainingSettingsComponent.vue";

export default {
  name: "TrainingInfosComponent",
  components: {
    TrainingSettingsComponent,
    TrainingProgramComponent,
    TrainingRncpComponent,
    TrainingGeneralInfoComponent,
    TrainingNpecComponent,
    BlockLoader,
  },
  props: {
    training: {
      type: Object,
      required: true,
      default: () => {},
    },
    settingsModels: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
    },
    logo: {
      type: String,
      required: false,
      default: "",
    },
    currentTabCode: {
      type: String,
      required: true,
    },
    npecModels: {
      type: Object,
      required: true,
    },
    cpneList: {
      type: Object,
      required: true,
    },
  },
  emits: ["updateField", "toggleTab", "refresh"],
  data() {
    return {};
  },
  computed: {
    tabs() {
      const tab = [
        { code: "info", title: this.$t("registration.training_info.info_tab.general_info") },
        { code: "rncp", title: this.$t("registration.training_info.info_tab.rncp_sheet") },
        { code: "program", title: this.$t("registration.training_info.info_tab.program") },
      ];
      if (moduleManager.isModuleActive(moduleConstantes.MODULE_STUDEA_REGISTRATION)) {
        tab.push(
          { code: "npec", title: this.$t("registration.training_info.info_tab.npec") },
          { code: "settings", title: this.$t("registration.training_info.info_tab.settings") },
        );
      }
      return tab;
    },
  },
  methods: {
    toggleTab(code) {
      this.$emit("toggleTab", code);
    },

    updateField(payload) {
      this.$emit("updateField", payload);
    },

    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-item {
  @include up-to-md {
    margin-left: 0 !important;
    width: 100%;
  }
}

.nav-item:not(:first-child) {
  @include up-to-md {
    margin-top: 15px !important;
  }
}

.widget-content,
.widget-heading {
  @include up-to-md {
    padding: 15px 10px !important;
  }
}
</style>
